"use strict";

exports.__esModule = true;
exports.default = exports.spaceOverrider = exports.getVariant = exports.getComponentName = void 0;

var getComponentName = function getComponentName(component) {
  if (component && component.props && component.props.displayName) {
    return component.props.displayName;
  }

  if (component && component.type && component.type.name) {
    return component.type.name;
  }

  return null;
};

exports.getComponentName = getComponentName;

var getVariant = function getVariant(component) {
  if (component && component.props && component.props.variant) {
    return component.props.variant;
  }

  return null;
};

exports.getVariant = getVariant;

var spaceOverrider = function spaceOverrider(component, space) {
  var componentName = getComponentName(component);
  var variant = getVariant(component);
  var componentLibrary = {
    Announcement: 'none',
    Billboard: 'none',
    Breadcrumbs: 'none',
    Countdown: variant === 'light' ? 'none' : space,
    Header: 'none',
    Hero: 'none',
    Quote: variant === 'primary' ? 'none' : space
  };
  return componentLibrary[componentName] || space;
};

exports.spaceOverrider = spaceOverrider;
var _default = spaceOverrider;
exports.default = _default;